<template>
  <div>
    <v-card ref="mBox" :elevation="'6'">
      <v-card-title ref="boxTitle" class="box-title py-2 px-2">
        <span v-html="title"></span>
        <v-spacer></v-spacer>
        <slot name="top-action-view"
      /></v-card-title>
      <div class="box-content">
        <slot name="default" />
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    type: String,
  },
  mounted() {
    this.checkType();
  },
  methods: {
    checkType() {
      if (this.type) {
        //this.$refs.boxTitle.style.background = 'hsl(0, 0%, 70%)'
        this.$refs.boxTitle.classList.value += " box-title-level-2";
        //this.$refs.mBox.classList.value += " box-level-2";
      }
    },
  },
};
</script>

<style>
.box-title {
  background: var(--color-primary);
  color: #f2f2f2;
  font-size: 1.1rem;
}
.box-content {
  background: var(--box-background);
  font-size: 0.92rem;
}
</style>